<!--https://app.swaggerhub.com/apis/pdn-mx/s1-Declaraciones-Inicial/2.0#/clientesPrincipales -->
<template>
  <div class="animated fadeIn">
    <loader :show="enviando" />
    <b-row>
      <!--GEMERAL-->
      <b-col sm="12">
        <h4 style="text-align: center">
          19. CLIENTES PRINCIPALES
        </h4>
      </b-col>

  
      <b-list-group sm="12">
        <b-list-group-item
          v-for="(item, index) in clientesPrincipales.cliente"
          :key="index"
        >
          <b-col md="12">
            <div class="customHr">.</div>
          </b-col>
          <b-col md="12">
            <h5 style="text-align: center">Cliente</h5>
          </b-col>
          <b-col md="12">
            <div class="customHr">.</div>
          </b-col>

          <!-- Formulario -->
          <b-col md="12">
            <b-row>
              <b-col sm="3">
                <b-form-group>
                  <label>Tipo Operación:</label>
                  <b-form-select
                    :disabled="status === 'Concluida'"
                     @change="cambiosClientes[index]=true"
                    v-model="item.tipoOperacion"
                    :options="tipoOperacion"
                    class="mb-3"
                  />
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group>
                  <label>Tipo Relación:</label>
                  <b-form-select
                  :disabled="status === 'Concluida'"
                    @change="cambiosClientes[index]=true"
                    v-model="item.tipoRelacion"
                    :options="tipoRelacion"
                    class="mb-3"
                  />
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group label="¿Realiza actividad lucrativa?">
                  <b-form-radio-group v-model="item.realizaActividadLucrativa" :disabled="status === 'Concluida'">
                    <b-form-radio value="true">Si</b-form-radio>
                    <b-form-radio value="false">No</b-form-radio>
                  </b-form-radio-group>
                </b-form-group>
              </b-col>

              
              <b-col md="6">
                <b-form-group>
                  <label>Nombre empresa:</label>
                  <b-form-input
                  :disabled="status === 'Concluida'"
                  @change="cambiosClientes[index]=true"
                    type="text"
                    v-model="item.empresa.nombreEmpresaServicio"
                    placeholder="Ingrese..."
                  ></b-form-input>
                </b-form-group>
              </b-col>
                  
              <b-col md="6">
                <b-form-group>
                  <label>RFC de la empresa:</label>
                  <b-form-input
                  :disabled="status === 'Concluida'"
              @change="cambiosClientes[index]=true"
                    type="text"
                    v-model="item.empresa.rfc"
                    placeholder="Ingrese..."
                  ></b-form-input>
                </b-form-group>
              </b-col>

              <b-col sm="3">
                <b-form-group>
                  <label>Tipo Persona:</label>
                  <b-form-select
                  :disabled="status === 'Concluida'"
        @change="cambiosClientes[index]=true"
                    v-model="item.clientePrincipal.tipoPersona"
                    :options="tipoPersona"
                    class="mb-3"
                  />
                </b-form-group>
              </b-col>

              <b-col md="6">
                <b-form-group>
                  <label>Nombre Razón Social:</label>
                  <b-form-input
                  :disabled="status === 'Concluida'"
                 @change="cambiosClientes[index]=true"
                    type="text"
                    v-model="item.clientePrincipal.nombreRazonSocial"
                    placeholder="Ingrese..."
                  ></b-form-input>
                </b-form-group>
              </b-col>
               <b-col sm="3">
                <b-form-group>
                  <label>Sector:</label>
                  <b-form-select
                  :disabled="status === 'Concluida'"
                    class="mb-3"
                    v-model="item.sector.clave"
                    :options="sector"
                    text-field="valor"
                    value-field="clave"
                    @change="seleccionaSectorValor(index)"
                  />
                </b-form-group>
              </b-col>

              
              <b-col md="4">
                <b-form-group>
                  <label>RFC del cliente principal:</label>
                  <b-form-input
                  :disabled="status === 'Concluida'"
                 @change="cambiosClientes[index]=true"
                    type="text"
                    v-model="item.clientePrincipal.rfc"
                    placeholder="Ingrese..."
                  ></b-form-input>
                </b-form-group>
              </b-col>

             

              <b-col md="2">
                <b-form-group>
                  <label>Monto ganancia:</label>
                  <b-form-input
                  :disabled="status === 'Concluida'"
              @change="cambiosClientes[index]=true"
                    type="text"
                    v-model="item.montoAproximadoGanancia.valor"
                    placeholder="Ingrese..."
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="1">
                <b-form-group>
                  <label>Moneda:</label>
                  <b-form-input
                    type="text"
                    v-model="item.montoAproximadoGanancia.moneda"
                    placeholder="MXN"
                    disabled
                  ></b-form-input>
                </b-form-group>
              </b-col>
              <b-col md="2">
              <b-form-group>
                <label>País:</label>
                <b-form-input v-model="item.ubicacion.pais" type="text" value="México" disabled></b-form-input>
              </b-form-group>
            </b-col>

    

              <b-col md="3">
                <b-form-group label="Estado:">
                  <b-form-select
                  :disabled="status === 'Concluida'"
                    @change="seleccionaValorEstado(index)"
                    :options="estados"
                    v-model="item.ubicacion.entidadFederativa.clave"
                    text-field="valor"
                    value-field="clave"
                    class="mb-3"
                  >
                  </b-form-select>
                </b-form-group>
              </b-col>

              <b-col md="12">
                <b-row style="text-align: center">
                  <b-col>
                    <b-button
                    v-if="status !== 'Concluida'"
                      variant="primary"
                      size="sm"
                      @click="guardarCliente(index)"
                      >Guardar</b-button
                    >
                    <br />
                    <p v-if="cambiosClientes[index]" class="error-text">
                      <i>No se han guardado los cambios</i>
                    </p>
                  </b-col>

                  <b-col>
                    <b-button
                    v-if="status !== 'Concluida'"
                      variant="danger"
                      size="sm"
                      @click="eliminarCliente(index)"
                      >Eliminar Cliente</b-button
                    >
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
          <br />
          <!-- FIN formulario -->
        </b-list-group-item>
      </b-list-group>
    </b-row>
    <br />
    <b-row>
      <b-col md="12">
        <b-button v-if="status !== 'Concluida'" variant="primary" size="sm" @click="nuevoCliente()"
          >Agregar Cliente</b-button
        >
      </b-col>
    </b-row>
    <br />

    <!--ACLARACIONES-->
    <b-row>
      <b-col md="12">
        <b-form-group>
          <label>Aclaraciones observaciones:</label>
          <b-form-input

          :disabled="status === 'Concluida'"
            type="text"
            @change="cambios = true"
            v-model="clientesPrincipales.aclaracionesObservaciones"
            placeholder="Ingrese..."
          ></b-form-input>
        </b-form-group>
      </b-col>
    </b-row>
    <br />
    <br />
    <b-row>
      <b-col md="4">
        <b-button  variant="success" @click="verSeccion(0)" :disabled="enviando"
          >Regresar al índice</b-button
        >
      </b-col>
      <b-col md="4" style="text-align: center">
        <b-button
        v-if="status !== 'Concluida'"
          variant="primary"
          @click="actualizarObservaciones()"
          :disabled="enviando"
          >Guardar cambios</b-button
        >
        <br />
        <p v-if="cambios" class="error-text">
          <i>No se han guardado los cambios</i>
        </p>
      </b-col>
      <b-col md="2" >
        <b-button
          variant="secondary"
          @click="verSeccion(18)"
          :disabled="enviando"
          >Anterior</b-button
        >
      </b-col>
       <b-col md="2">
        <b-button
      
          class="pull-right"
          variant="secondary"
          @click="verSeccion(20)"
          :disabled="enviando"
          >Siguiente</b-button
        >
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import swal from "sweetalert";
import Loader from "../../../views/Loader";
import { mapGetters } from "vuex";
import { Datetime } from "vue-datetime";
import "vue-datetime/dist/vue-datetime.css";
import { muni } from "../../../store/municipios";
import { paises } from "../../../store/paises";

export default {
  components: { Loader, Datetime },
  props: ["clientesPrincipales", "status"],
  computed: {
    ...mapGetters(["httpURL", "sessionToken"])
  },
  data: function() {
    return {
      titulo: this.$route.name,
      enviando: false,
      cambios: false,
      cambiosClientes: [],
      contadorClientes: 0,
      pais: paises,
      tipoOperacion: ["AGREGAR", "MODIFICAR", "SIN_CAMBIOS", "BAJA"],
      tipoRelacion: ["DECLARANTE", "PAREJA", "DEPENDIENTE_ECONOMICO"],
      tipoPersona: ["FISICA", "MORAL"],
      sector: [
        { clave: "AGRI", valor: "AGRICULTURA" },
        { clave: "MIN", valor: "MINERÍA" },
        { clave: "EELECT", valor: "ENERGÍA ELÉCTRICA" },
        { clave: "CONS", valor: "CONSTRUCCIÓN" },
        { clave: "INDMANU", valor: "INDUSTRIA MANUFACTURERA" },
        { clave: "CMAYOR", valor: "COMERCIO AL POR MAYOR" },
        { clave: "CMENOR", valor: "COMERCIO AL POR MENOR" },
        { clave: "TRANS", valor: "TRANSPORTE" },
        { clave: "MEDIOM", valor: "MEDIOS MASIVOS" },
        { clave: "SERVFIN", valor: "SERVICIOS FINANCIEROS" },
        { clave: "SERVPROF", valor: "SERVICIOS PROFESIONALES" },
        { clave: "SERVINM", valor: "SERVICIOS INMOBILIARIOS" },
        { clave: "SERVCORP", valor: "SERVICIOS CORPORATIVOS" },
        { clave: "SERVS", valor: "SERVICIOS DE SALUD" },
        { clave: "SERVESPAR", valor: "SERVICIOS DE ESPARCIMIENTO" },
        { clave: "SERVALOJ", valor: "SERVICIOS DE ALOJAMIENTO" },
        { clave: "OTRO", valor: "OTRO" }
      ],
      estados: [
        { clave: "01", valor: "AGUASCALIENTES" },
        { clave: "02", valor: "BAJA CALIFORNIA" },
        { clave: "03", valor: "BAJA CALIFORNIA SUR" },
        { clave: "04", valor: "CAMPECHE" },
        { clave: "05", valor: "COAHUILA DE ZARAGOZA" },
        { clave: "06", valor: "COLIMA" },
        { clave: "07", valor: "CHIAPAS" },
        { clave: "08", valor: "CHIHUAHUA" },
        { clave: "09", valor: "DISTRITO FEDERAL" },
        { clave: "10", valor: "DURANGO" },
        { clave: "11", valor: "GUANAJUATO" },
        { clave: "12", valor: "GUERRERO" },
        { clave: "13", valor: "HIDALGO" },
        { clave: "14", valor: "JALISCO" },
        { clave: "15", valor: "MéXICO" },
        { clave: "16", valor: "MICHOACÁN DE OCAMPO" },
        { clave: "17", valor: "MORELOS" },
        { clave: "18", valor: "NAYARIT" },
        { clave: "19", valor: "NUEVO LEÓN" },
        { clave: "20", valor: "OAXACA" },
        { clave: "21", valor: "PUEBLA" },
        { clave: "22", valor: "QUERÉTARO" },
        { clave: "23", valor: "QUINTANA ROO" },
        { clave: "24", valor: "SAN LUIS POTOSÍ" },
        { clave: "25", valor: "SINALOA" },
        { clave: "26", valor: "SONORA" },
        { clave: "27", valor: "TABASCO" },
        { clave: "28", valor: "TAMAULIPAS" },
        { clave: "29", valor: "TLAXCALA" },
        { clave: "30", valor: "VERACRUZ DE IGNACIO DE LA LLAVE" },
        { clave: "31", valor: "YUCATÁN" },
        { clave: "32", valor: "ZACATECAS" }
      ]
    };
  },
  methods: {
    verSeccion(sec) {
      this.$emit("verSeccion", sec);
    },
    // checarCambios(item, indice) {
    //   let index = this.cambiosClientes.findIndex(x => x._id == item._id);

    //   return this.cambiosClientes[indice].cambios;
    //   //return false;
    // },
    // seRealizaronCambiios(item) {
    //   let index = this.cambiosClientes.findIndex(x => x._id == item._id);
    //   this.cambiosClientes[index].cambios = true;
    // },
    verSeccion(sec) {
      this.$emit("verSeccion", sec);
    },
    seleccionaSectorValor(index) {
      let indice = this.sector.findIndex(
        x => x.clave == this.clientesPrincipales.cliente[index].sector.clave
      );
      this.clientesPrincipales.cliente[index].sector.valor = this.sector[
        indice
      ].valor;
    },
    seleccionaValorEstado(index) {
      let indice = this.estados.findIndex(
        x =>
          x.clave ==
          this.clientesPrincipales.cliente[index].ubicacion.entidadFederativa
            .clave
      );
      this.clientesPrincipales.cliente[
        index
      ].ubicacion.entidadFederativa.valor = this.estados[indice].valor;
    },

    actualizarObservaciones() {
      this.enviando = true;

      axios
        .put(
          this.httpURL +
            "/declaraciones/V2/clientesPrincipales/" +
            this.$route.params.id +
            "/aclaracionesObservaciones",

          {
            ninguno: this.clientesPrincipales.ninguno,
            aclaracionesObservaciones: this.clientesPrincipales
              .aclaracionesObservaciones
          },
          { headers: { token: this.sessionToken } }
        )
        .then(res => {
        
          if (res.data.ok == true) {
            this.$notify({
              group: "foo",
              type: "success",
              duration: 2500,
              speed: 1000,
              text: res.data.mensaje
            });
          }
          this.enviando = false;
          this.cambios = false;
          this.$forceUpdate();
        })
        .catch(error => {
          this.$notify({
            group: "foo",
            type: "error",
            duration: 2500,
            speed: 1000,
            text: "No se pudo guardar la sección."
          });
          this.enviando = false;
          
        });
    },

    nuevoCliente() {
      axios
        .post(
          this.httpURL +
            "/declaraciones/V2/clientesPrincipales/" +
            this.$route.params.id +
            "/cliente",

          {},
          { headers: { token: this.sessionToken } }
        )
        .then(res => {
        
          let objeto = { _id: this.contadorClientes, cambios: false };
          this.cambiosClientes.push(objeto);
          this.clientesPrincipales.cliente.push(res.data.cliente);
          this.contadorClientes++;
          this.enviando = true;
          this.$notify({
            group: "foo",
            type: "success",
            duration: 2500,
            speed: 1000,
            text: res.data.mensaje
          });
          this.enviando = false;
        })
        .catch(error => {
          if (error.response) {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: error.response.data.mensaje
            });
          } else if (error.request) {
            this.$notify({
              group: "foo",
              type: "error",
              duration: 2500,
              speed: 1000,
              text: "No se pudo establecer una conexión al servidor."
            });
          }
          this.enviando = false;
        });
    },
    eliminarCliente(index) {
      swal({
        text: "¿Está seguro en eliminar el cliente?",

        buttons: true,
        dangerMode: true
      }).then(willDelete => {
        if (willDelete) {
          axios
            .delete(
              this.httpURL +
                "/declaraciones/V2/clientesPrincipales/" +
                this.$route.params.id +
                "/cliente/" +
                this.clientesPrincipales.cliente[index]._id,

              { headers: { token: this.sessionToken } }
            )
            .then(res => {
             
              if (res.data.ok == true) {
                this.$notify({
                  group: "foo",
                  type: "success",
                  duration: 2500,
                  speed: 1000,
                  text: res.data.mensaje
                });

                this.clientesPrincipales.cliente.splice(index, 1);
                this.cambiosClientes.splice(index, 1);
                this.contadorClientes--;
              }

              this.enviando = false;
            })
            .catch(error => {
              this.$notify({
                group: "foo",
                type: "error",
                duration: 2500,
                speed: 1000,
                text: "No se pudo guardar la sección."
              });
              this.enviando = false;
             
            });
        }
      });
    },
     guardarCliente(index) {
      this.enviando = true;

      axios
        .put(
          this.httpURL +
            "/declaraciones/V2/clientesPrincipales/" +
            this.$route.params.id +
            "/cliente/" +
            this.clientesPrincipales.cliente[index]._id,
          {
            tipoOperacion: this.clientesPrincipales.cliente[index].tipoOperacion,
            realizaActividadLucrativa: this.clientesPrincipales.cliente[index].realizaActividadLucrativa,
            tipoRelacion: this.clientesPrincipales.cliente[index].tipoRelacion,
            nombreEmpresaServicio: this.clientesPrincipales.cliente[index].empresa.nombreEmpresaServicio,
            rfcEmpresa: this.clientesPrincipales.cliente[index].empresa.rfc,
            clientePrincipalTipoPersona: this.clientesPrincipales.cliente[index].clientePrincipal.tipoPersona,
            clientePrincipalNombreRazonSocial: this.clientesPrincipales.cliente[index].clientePrincipal.nombreRazonSocial,
            clientePrincipalRFC: this.clientesPrincipales.cliente[index].clientePrincipal.rfc,
            sectorClave: this.clientesPrincipales.cliente[index].sector.clave,
            sectorValor: this.clientesPrincipales.cliente[index].sector.valor,
            montoAproximadoGananciaValor: this.clientesPrincipales.cliente[index].montoAproximadoGanancia.valor,
            montoAproximadoGananciaMoneda: this.clientesPrincipales.cliente[index].montoAproximadoGanancia.moneda,
            ubicacionPais: this.clientesPrincipales.cliente[index].ubicacion.pais,
            entidadFederativaClave: this.clientesPrincipales.cliente[index].ubicacion.entidadFederativa.clave,
            entidadFederativaValor: this.clientesPrincipales.cliente[index].ubicacion.entidadFederativa.valor
          },
          { headers: { token: this.sessionToken } }
        )
        .then(res => {
        
            this.$notify({
              group: "foo",
              type: "success",
              duration: 2500,
              speed: 1000,
              text: res.data.mensaje
            });
            this.cambiosClientes[index] = false;
            this.$forceUpdate();
            this.enviando = false;
        })
        .catch(error => {
          this.$notify({
            group: "foo",
            type: "error",
            duration: 2500,
            speed: 1000,
            text: "No se pudo guardar la sección."
          });
          this.enviando = false;
        });
    }
  },

  created() {
  

    if (this.clientesPrincipales.cliente.length > 0) {
      this.clientesPrincipales.cliente.forEach(Element => {
        this.cambiosClientes.push(false);
      });
    }
  }
};
</script>

<style>
.customHr {
  width: 100%;
  font-size: 1px;
  color: rgba(0, 0, 0, 0);
  line-height: 1px;

  background-color: grey;
  margin-top: 0px;
  margin-bottom: 10px;
}
.error-texr {
  color: #ff0000;
}
</style>
